import React from "react";
import { ListItem, ListItemText } from "@material-ui/core";

type OptionProps<T> = Partial<{
  children: React.ReactNode;
}> & {
  item: T;
  onChange: (data?: T) => void;
  getOptionLabel: (data: T) => React.ReactNode;
  close: () => void;
};

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions,react/function-component-definition
function Option<T>({
  children,
  item,
  onChange,
  getOptionLabel,
  close,
}: OptionProps<T>): React.ReactElement {
  return (
    <ListItem
      className="h-[35px] w-[inherit] cursor-pointer p-0"
      onClick={() => {
        onChange(item);
        close();
      }}
    >
      <ListItemText
        primary={
          children ?? (
            <section className="w-full truncate leading-none text-gray-500">
              {item ? getOptionLabel(item) : ""}
            </section>
          )
        }
      />
    </ListItem>
  );
}

export { Option };
